"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceItem = void 0;
class InvoiceItem {
    get baseInvoiceAmountDisplay() {
        return (this.invoiceBaseAmount / 100).toFixed(2);
    }
    get baseAmountDisplay() {
        return (this.baseAmount / 100).toFixed(2);
    }
    get invoiceVatAmountDisplay() {
        return (this.invoiceVatAmount / 100).toFixed(2);
    }
    get vatAmountDisplay() {
        return (this.vatAmount / 100).toFixed(2);
    }
    get invoiceAmountDisplay() {
        return ((this.invoiceBaseAmount + this.invoiceVatAmount) / 100).toFixed(2);
    }
}
exports.InvoiceItem = InvoiceItem;
//# sourceMappingURL=InvoiceItem.js.map